export const CONTENT_SECTIONS = {
  AWARD: 'Award',
  COMMON_QUESTIONS: 'CommonQuestions',
  CONTACT_DETAILS: 'ContactDetails',
  HEADER: 'header',
  OFFER: 'offer',
  PRODUCT_LISTING: 'ProductListing',
  SALES_JOURNEY: 'SalesJourney',
  SELLING_POINTS_GROUP: 'SellingPointGroup',
  TILES: 'ContentTiles',
  VALUE_PROPOSITIONS: 'ValuePropositionsObject',
} as const;

export const CONSIDERATION_TYPES = ['health-insurance-ccs'];
